var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['ui-icon', _vm.plain ? 'ui-icon-plain' : `ui-icon-${_vm.color}`, `ui-icon-${_vm.size}`]},[_c('i',{class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }